/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import { formatLegacyProgramUrl, formatProgramUrl } from '../../helpers';
import { GROUPING_MIN_PROGRAM_DURATION } from '../../constants';
import ModalProgram from './ModalProgram';
import { ProgramLink } from './ProgramLink';

const Wrapper = styled.div`
  cursor: pointer;
`;

const Dots = styled.p`
  font-size: ${pxInRem('18px')};
  color: ${props => props.theme.tvGuide.program.dots.color};
`;

const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const Program = ({
  className,
  timezone,
  urlPattern,
  channel,
  programs,
  width,
  isNew,
  duration = 0
}) => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [showPicture, setShowPicture] = React.useState(true);

  const hasManyPrograms = programs.length > 1;

  const shouldShowDots =
    hasManyPrograms || duration < GROUPING_MIN_PROGRAM_DURATION;

  const firstProgram = programs[0];
  const style = width ? { width: `${width}%` } : {};

  const programLink = React.useMemo(
    () =>
      isNew
        ? formatProgramUrl(urlPattern, firstProgram)
        : formatLegacyProgramUrl(urlPattern, firstProgram),
    [urlPattern, isNew, firstProgram]
  );

  return (
    <Wrapper className={className} style={style}>
      {shouldShowDots && (
        <DotsWrapper onClick={() => setModalIsOpen(!modalIsOpen)}>
          <Dots>...</Dots>
        </DotsWrapper>
      )}

      {!shouldShowDots && firstProgram && (
        <ProgramLink
          programLink={programLink}
          firstProgram={firstProgram}
          timezone={timezone}
          showPicture={showPicture}
          setPictureOnError={() => setShowPicture(false)}
        />
      )}

      {modalIsOpen && (
        <ModalProgram
          timezone={timezone}
          channel={channel}
          programs={programs}
          onCloseRequest={() => setModalIsOpen(!modalIsOpen)}
          urlPattern={urlPattern}
        />
      )}
    </Wrapper>
  );
};

Program.displayName = 'Program';

export default Program;
